// extracted by mini-css-extract-plugin
export default {"fishbowl-wrapper":"HeaderCsb_fishbowl-wrapper__xlbPv"};